import Vue from 'vue'
import Router from 'vue-router'
import Auth from '@/page/Auth'
import Sleepq from '@/page/sleepq/index'
import Test from '@/page/test/index'
import Hospital from '@/page/hospital/index'
import My from '@/page/hospital/My';
import ShortUrl from '@/page/shorturl/index'
import Zone from '@/page/zone/index'
import Xi from '@/page/showcase/Xi'
import XiHome from '@/page/showcase/Home'
import XiMenu from '@/page/showcase/Menu'
import XiSignUp from '@/page/showcase/SignUp'
import XiPreview from '@/page/showcase/Preview'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/sleepq',
      name: 'sleepq',
      component: Sleepq,
      meta: { title: '슬립큐전용' }
    },
    {
      path: '/test',
      name: 'test',
      component: Test,
      meta: { title: '테스트환경' }
    },
    {
      path: '/auth/callback',
      name: 'auth',
      component: Auth
    },
    {
      path: '/hospital/:uuid',
      name: 'hospital',
      component: Hospital,
      meta: { title: '솔닥' }
    },
      {
      path: '/my/hospital',
      name: 'my',
      component: My,
      meta: { title: '솔닥' }
    },
    {
      path: '/shorturl',
      name: 'shorturl',
      component: ShortUrl
    },
    {
      path: '/zone',
      name: 'zone',
      component: Zone
    },
    {
      path: '/xi',
      name: 'xi',
      component: Xi,
      redirect: '/xi/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: XiHome
        },
        {
          path: 'signup',
          name: 'signup',
          component: XiSignUp
        },
        {
          path: 'preview',
          name: 'preview',
          component: XiPreview
        }
      ],
      meta: { title: '자이모델하우스' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js